const fr: Record<string, string> = {
  "Virtual Try-On": "Essayage Virtuel",
  "Find Your Size & See It On You": "Trouvez votre taille et essayez-le",
  "See Your Fit": "Voir votre ajustement",
  "Check your size, then try it on virtually": "Vérifiez votre taille, puis essayez-le virtuellement",
  "Get Your Size": "Votre taille",
  "Instant fit suggestion": "Suggestion de coupe instantanée",
  "Try It On": "Essayer",
  "See how it looks on you": "Voyez comment ça vous va",
  "Find My Size": "Trouver ma taille",
  "Takes less than a minute": "Prend moins d'une minute",
  "Upload a full body photo": "Téléchargez une photo en pied",
  "JPEG, PNG or WebP (max 10MB)": "JPEG, PNG ou WebP (max 10 Mo)",
  "Your photo": "Votre photo",
  "Let's find your best fit": "Trouvons votre meilleure coupe",
  "Centimeters": "Centimètres",
  "Inches": "Pouces",
  "Load saved profile...": "Charger un profil enregistré...",
  "HEIGHT": "TAILLE",
  "WEIGHT": "POIDS",
  "feet": "pieds",
  "inches": "pouces",
  "cm": "cm",
  "kg": "kg",
  "lbs": "livres",
  "in": "po",
  "How to measure": "Comment mesurer",
  "Hide guide": "Masquer le guide",
  "I know my measurements": "Je connais mes mesures",
  "Not sure? Use height & weight instead": "Pas sûr ? Utilisez taille et poids",
  "Please fill in height and weight": "Veuillez renseigner la taille et le poids",
  "Please fill in all required fields": "Veuillez remplir tous les champs obligatoires",
  "Next": "Suivant",
  "Analyzing your size...": "Analyse de votre taille...",
  "SUGGESTED SIZE": "TAILLE SUGGÉRÉE",
  "NOT SUGGESTED": "NON SUGGÉRÉE",
  "Edit measurements": "Modifier les mesures",
  "Size guide": "Guide des tailles",
  "Your fit": "Votre coupe",
  "Your Suggested Size": "Votre taille suggérée",
  "Your measure": "Votre mesure",
  "within range": "dans la plage",
  "too tight": "trop serré",
  "tight": "serré",
  "a bit tight": "un peu serré",
  "too loose": "trop ample",
  "loose": "ample",
  "a bit loose": "un peu ample",
  "See fit on your photo": "Voir la coupe sur votre photo",
  "Hide visual fit": "Masquer la coupe visuelle",
  "Analyzing...": "Analyse...",
  "Try it on": "Essayer",
  "SIZE CHART": "TABLEAU DES TAILLES",
  "YOUR ESTIMATED MEASUREMENTS": "VOS MESURES ESTIMÉES",
  "Edit": "Modifier",
  "Download": "Télécharger",
  "Size chart": "Tableau des tailles",
  "Preparing your image...": "Préparation de votre image...",
  "Analyzing body proportions...": "Analyse des proportions corporelles...",
  "Matching garment to your photo...": "Ajustement du vêtement à votre photo...",
  "Generating virtual try-on...": "Génération de l'essayage virtuel...",
  "Refining details...": "Affinement des détails...",
  "Almost there...": "Presque terminé...",
  "Complete!": "Terminé !",
  "This usually takes 15-25 seconds": "Cela prend généralement 15 à 25 secondes",
  "Something went wrong": "Une erreur est survenue",
  "Try Again": "Réessayer",
  "We couldn't find a matching size for you": "Nous n'avons pas trouvé de taille adaptée pour vous",
  "Please try the manual measurement screen so we can calculate your fit from your measurements.": "Essayez l'écran de mesures manuelles afin que nous puissions calculer votre coupe à partir de vos mesures.",
  "Try manual measurements": "Essayer les mesures manuelles",
  "SDK not configured. Please provide an API key.": "SDK non configuré. Veuillez fournir une clé API.",
  "Please upload a JPEG, PNG, or WebP image.": "Veuillez télécharger une image JPEG, PNG ou WebP.",
  "Image must be under 10MB.": "L'image doit faire moins de 10 Mo.",
  "Try-on generation failed": "Échec de la génération de l'essayage",
  "Failed to start try-on": "Impossible de démarrer l'essayage",
  "No product image found. Please set the product-image attribute.": "Aucune image produit trouvée. Veuillez définir l'attribut product-image.",
  "Powered by": "Propulsé par",
  "My Profiles": "Mes Profils",
  "History": "Historique",
  "No saved profiles yet.": "Aucun profil enregistré.",
  "No history yet.": "Pas encore d'historique.",
  "Product": "Produit",
  "Women's": "Femme",
  "Men's": "Homme",
  "Profiles": "Profils",
  "Women's Profile": "Profil Femme",
  "Men's Profile": "Profil Homme",
  "Height": "Taille",
  "Weight": "Poids",
  "Chest": "Poitrine",
  "Bust": "Buste",
  "Waist": "Tour de taille",
  "Hips": "Hanches",
  "Shoulders": "Épaules",
  "Sleeve": "Manche",
  "Inseam": "Entrejambe",
  "Neck": "Cou",
  "Foot": "Pied",
  "Shoe EU": "Chaussure EU",
  "Shoe US": "Chaussure US",
  "Shoe UK": "Chaussure UK",
  "Saved": "Enregistré",
  "Delete Profile": "Supprimer le Profil",
  "Shoe size (US)": "Pointure (US)",
  "Shoe size (UK)": "Pointure (UK)",
  "Shoe size (EU)": "Pointure (EU)",
  "Generating...": "Génération...",
  "Foot length": "Longueur du pied",
  "Size": "Taille",
  "Try on size": "Essayer la taille",
  "e.g.": "ex.",
  "Drop your photo here or click to upload": "Déposez votre photo ici ou cliquez pour télécharger",
  "This usually takes 15-20 seconds": "Cela prend généralement 15 à 20 secondes",
  "Try-on result": "Résultat de l'essayage",
  "Try Another": "Essayer une autre",
  "Back": "Retour",
  "You": "Vous",
  "Garment": "Vêtement",
  "Your Height": "Votre Taille",
  "Your Weight": "Votre Poids",
  "Drag or scroll to set your height": "Glissez ou faites défiler pour définir votre taille",
  "Drag or scroll to set your weight": "Glissez ou faites défiler pour définir votre poids",
  "Enter height and weight first": "Saisissez d'abord la taille et le poids",

  // ── Field labels ──
  "Lens Width": "Largeur du verre",
  "Bridge": "Pont",
  "Arm Length": "Longueur de branche",
  "Head Circumference": "Tour de tête",
  "Face Width": "Largeur du visage",
  "Temple": "Branche",
  "Around widest point": "Autour du point le plus large",
  "Foot Length": "Longueur du pied",
  "Shoulder": "Épaule",
  "Thigh": "Cuisse",
  "Hip": "Hanche",

  // ── Units ──
  "Millimetre": "Millimètre",
  "Centimetre": "Centimètre",
  "Millimeters": "Millimètres",

  // ── Fit descriptors ──
  "Tight": "Serré",
  "Loose": "Lâche",
  "Short": "Court",
  "Long": "Long",
  "✓ Fit": "✓ Ajusté",
  "too short": "trop court",
  "too long": "trop long",
  "a bit short": "un peu court",
  "a bit long": "un peu long",

  // ── Length pills ──
  "Length": "Longueur",
  "Length Adjustment": "Ajustement de longueur",
  "Regular": "Régulier",
  "Big": "Grand",
  "Big & Tall": "Grand & Long",

  // ── Misc ──
  "preview": "aperçu",

  // ── BodyProfileView — photo upload area (left section) ──
  "Upload your photo": "Téléchargez votre photo",
  "Upload a photo": "Télécharger une photo",
  "Click or drag a full-body photo": "Cliquez ou faites glisser une photo en pied",
  "Or upload a photo for AI sizing": "Ou téléchargez une photo pour l'analyse par IA",
  "Photo": "Photo",
  "How to take a good photo": "Comment prendre une bonne photo",
  "How to take the best photo": "Comment prendre la meilleure photo",
  "Do": "À faire",
  "Don't": "À éviter",
  "Quick Tip": "Astuce rapide",
  "The simpler your photo is, the more accurate your virtual try-on results will be.": "Plus votre photo est simple, plus les résultats de l'essayage virtuel seront précis.",
  "Choose a plain background (a light wall is ideal)": "Choisissez un arrière-plan uni (un mur clair est idéal)",
  "Stand facing the camera with your full body in frame": "Tenez-vous face à la caméra avec tout votre corps dans le cadre",
  "Stand straight and still, arms relaxed by your sides": "Tenez-vous droit et immobile, bras détendus le long du corps",
  "Stand with your HEELS against a wall for best accuracy": "Placez vos TALONS contre un mur pour une meilleure précision",
  "Use natural or even lighting (e.g. near a window)": "Utilisez un éclairage naturel ou uniforme (par ex. près d'une fenêtre)",
  "Wear fitted, simple clothing (e.g. neutral colors)": "Portez des vêtements ajustés et simples (par ex. couleurs neutres)",
  "Don't wear loose, baggy, or layered clothing": "Ne portez pas de vêtements amples ou superposés",
  "Don't sit, pose, or bend your body": "Ne vous asseyez pas, ne posez pas et ne courbez pas votre corps",
  "Don't use strong backlighting": "N'utilisez pas de contre-jour fort",
  "Don't take mirror photos or selfies": "Ne prenez pas de photos miroir ni de selfies",
  "Don't apply filters, effects, or edits": "N'appliquez pas de filtres, d'effets ou d'éditions",

  // ── Age gate ──
  "Are you 18 or older?": "Avez-vous 18 ans ou plus ?",
  "Yes": "Oui",
  "No": "Non",
  "Please confirm your age": "Veuillez confirmer votre âge",
  "Please confirm that the person in the photo is 18 or older before uploading.": "Veuillez confirmer que la personne sur la photo a 18 ans ou plus avant le téléchargement.",
  "Under 18 — can't process this photo.": "Moins de 18 ans — impossible de traiter cette photo.",
  "This photo appears to be of a minor. Please upload a photo of someone 18 or older.": "Cette photo semble être celle d'un mineur. Veuillez télécharger la photo d'une personne de 18 ans ou plus.",
  "Different photo needed": "Une autre photo est nécessaire",
  "Try another photo": "Essayez une autre photo",

  // ── Photo step controls ──
  "Continue": "Continuer",
  "Analyze My Size": "Analyser ma taille",
  "Analyzing photo…": "Analyse de la photo…",
  "Details": "Détails",
  "Image must be under 10MB": "L'image doit faire moins de 10 Mo",
  "Please upload an image file": "Veuillez télécharger un fichier image",
  "Please upload a photo": "Veuillez télécharger une photo",
  "Prefer not to upload a photo?": "Vous préférez ne pas télécharger de photo ?",
  "Enter measurements manually": "Saisir les mesures manuellement",
  "Legal Notice": "Mention légale",
  "Your image will be used to generate a virtual try-on preview showing how selected items may look and fit. Images are processed securely and are not stored after generation.": "Votre image sera utilisée pour générer un aperçu d'essayage virtuel montrant l'apparence et l'ajustement des articles sélectionnés. Les images sont traitées de manière sécurisée et ne sont pas conservées après la génération.",

  // ── BodyProfileView — form (right section) ──
  "Body details": "Détails corporels",
  "Your body details": "Vos détails corporels",
  "Body Measurements": "Mensurations",
  "AGE": "ÂGE",
  "years": "ans",
  "Enter your height": "Saisissez votre taille",
  "Enter your weight": "Saisissez votre poids",
  "Enter your bra size": "Saisissez votre taille de soutien-gorge",
  "Please enter your height": "Veuillez saisir votre taille",
  "Please enter your weight": "Veuillez saisir votre poids",
  "Please enter a valid height": "Veuillez saisir une taille valide",
  "Please enter a valid weight": "Veuillez saisir un poids valide",
  "Please enter a valid height (100-250 cm)": "Veuillez saisir une taille valide (100-250 cm)",
  "Please enter a valid weight (30-300 kg)": "Veuillez saisir un poids valide (30-300 kg)",
  "Please select both band and cup size": "Veuillez sélectionner la taille de tour de poitrine et de bonnet",
  "Select your bra size": "Sélectionnez votre taille de soutien-gorge",
  "BAND": "TOUR",
  "BAND SIZE": "TOUR DE POITRINE",
  "CUP": "BONNET",
  "CUP SIZE": "TAILLE DE BONNET",
  "BRA REGION": "RÉGION DU SOUTIEN-GORGE",
  "Imperial": "Impérial",
  "Metric": "Métrique",
  "These calibrate the AI — all required.": "Ces données calibrent l'IA — toutes obligatoires.",
  "Using": "Utilise",
  "start fresh": "recommencer",
  "Close": "Fermer",

  // ── Body shape questions ──
  "Which best describes your chest?": "Lequel décrit le mieux votre poitrine ?",
  "WHICH BEST DESCRIBES YOUR CHEST?": "LEQUEL DÉCRIT LE MIEUX VOTRE POITRINE ?",
  "Which best describes your hips?": "Lequel décrit le mieux vos hanches ?",
  "WHICH BEST DESCRIBES YOUR HIPS?": "LEQUEL DÉCRIT LE MIEUX VOS HANCHES ?",
  "Which best describes your midsection?": "Lequel décrit le mieux votre taille ?",
  "WHICH BEST DESCRIBES YOUR MIDSECTION?": "LEQUEL DÉCRIT LE MIEUX VOTRE TAILLE ?",
  "Which best describes your seat?": "Lequel décrit le mieux votre assise ?",
  "WHICH BEST DESCRIBES YOUR SEAT?": "LEQUEL DÉCRIT LE MIEUX VOTRE ASSISE ?",
  "Average": "Moyenne",
  "Narrow": "Étroit",
  "Broad": "Large",
  "Curvy": "Sinueux",
  "A slimmer, narrower chest build": "Une poitrine plus mince et étroite",
  "A moderate, proportionate chest": "Une poitrine modérée et proportionnée",
  "A wider, more muscular chest": "Une poitrine plus large et musclée",
  "A flatter midsection with minimal protrusion": "Une taille plus plate avec peu de protubérance",
  "A moderate, natural midsection shape": "Une taille modérée et naturelle",
  "A fuller, more rounded midsection": "Une taille plus pleine et arrondie",
  "A flatter backside with less projection": "Un arrière plus plat avec moins de projection",
  "A moderate, natural backside shape": "Un arrière modéré et naturel",
  "A fuller, more rounded backside": "Un arrière plus plein et arrondi",

  // ── Photo step — profile photo preload pill ──
  "Loaded from profile": "Chargée depuis le profil",
  "Clear": "Effacer",
};
export default fr;
